import React, { Component } from "react";
import { Form, Field } from "react-final-form";

import { withStyles } from "@material-ui/styles";
import styles from "./styles";
import Button from "react-bootstrap/Button";

import FormInput from "../../Components/FormInput/FormInput";
import LoadingIcon from "../../Components/LoadingIcon";

const validate = values => {
  const errors = {};
  if (!values.oldPassword) {
    errors.oldPassword = "Required";
  }
  if (!values.newPassword) {
    errors.newPassword = "Required";
  }
  if (values.newPassword !== values.confirmPassword) {
    errors.confirmPassword = "Passwords don't match";
  }
  return errors;
};

class PasswordForm extends Component {
  render() {
    const {
      handleSubmit,
      classes,
      passwordResetSuccess,
      passwordResetError,
      fetching,
    } = this.props;
    return (
      <div
        className={`
          ${classes.settings} ${passwordResetError &&
          classes.settingsError} ${passwordResetSuccess &&
          classes.settingsSuccess}`}
      >
        <Form onSubmit={handleSubmit} validate={validate}>
          {({ handleSubmit }) => (
            <form onSubmit={handleSubmit} className={classes.formContainer}>
              <div className={classes.formInput}>
                <div className={classes.passwordField}>
                  <Field
                    name={"oldPassword"}
                    render={props => {
                      return (
                        <FormInput
                          {...props}
                          placeholder={"Insert Old Password"}
                          type={"password"}
                        />
                      );
                    }}
                  />
                </div>
              </div>
              <div className={classes.formInput}>
                <div className={classes.passwordField}>
                  <Field
                    name={"newPassword"}
                    render={props => {
                      return (
                        <FormInput
                          {...props}
                          placeholder={"Insert New Password"}
                          type={"password"}
                        />
                      );
                    }}
                  />
                </div>
              </div>
              <div className={classes.formInput}>
                <div className={classes.passwordField}>
                  <Field
                    name={"confirmPassword"}
                    render={props => {
                      return (
                        <FormInput
                          {...props}
                          placeholder={"Confirm New Password"}
                          type={"password"}
                        />
                      );
                    }}
                  />
                </div>
              </div>
              {passwordResetError && (
                <div className={classes.errorContainer}>
                  <p className={classes.errorText}>{passwordResetError}</p>
                </div>
              )}
              {passwordResetSuccess && (
                <div className={classes.successContainer}>
                  <p className={classes.successText}>
                    Password successfully changed
                  </p>
                </div>
              )}
              <div className={classes.buttons}>
                <Button type="submit">
                  Save {fetching && <LoadingIcon />}
                </Button>
              </div>
            </form>
          )}
        </Form>
      </div>
    );
  }
}

export default withStyles(styles)(PasswordForm);
